import CalculatorWebView from "./CalculatorWeb";
import { useMediaQuery } from "@mui/material";
import CalculatorMobileView from "./CalculatorMob";
export default function Calculator() {
    const isSmallScreen = useMediaQuery("(max-width:900px)");
    return <>{isSmallScreen ? <CalculatorMobileView /> : <CalculatorWebView />}</>;
}
